module.exports = __webpack_public_path__ + "static/media/Traveller.52e295fe.png";